import { z } from "zod";
import { TransferPaymentFineEnum } from "../../enums";

export const LoanSchema = z.object({
  id: z.string().uuid().optional(),
  interestRate: z.string().optional().or(z.number().optional()),
  interestCalculationMethod: z.string().optional(),
  repaymentPeriod: z.number().optional(),
  transferPaymentFineType:
    TransferPaymentFineEnum.transferPaymentFineTypeSchema.optional(),
  amountLimit: z.number().optional(),
  percentageAmountLateFine: z.string().optional(),
  fixedAmountLateFine: z.string().nullable().optional(),
  percentageMarginCall: z.number().optional(),
  percentageLiquidThreshold: z.number().optional(),
  collateral: z.any().nullable().optional(),
  minimumLtv: z.number().optional(),
  maximumLtv: z.number().optional(),
  currency: z.string().optional(),
  network: z.string().optional(),
  status: z.string().nullable().optional(),
  minimumRank: z.string().optional(),
  createdAt: z.string().datetime().optional(),
  updatedAt: z.string().datetime().optional(),
  installmentNumber: z.number().optional().nullable(),
  monthlyRepay: z.number().optional().nullable(),
});

export type LoanSchemaType = z.infer<typeof LoanSchema>;
